import React, { FC } from 'react';

type TProps = {
    locale: string;
    width?: number;
};

const US_STARS: Array<[number, number]> = Array.from({ length: 9 }, (_, row) => {
    const count = row % 2 === 0 ? 6 : 5;
    const cantonWidth = 9.6;
    const cantonHeight = (7 * 16) / 13;
    const dx = cantonWidth / 12;
    const dy = cantonHeight / 10;

    return Array.from({ length: count }, (_, col) => {
        const x = dx * (row % 2 === 0 ? col * 2 + 1 : col * 2 + 2);
        const y = dy * (row + 1);
        return [x, y] as [number, number];
    });
}).flat();

const FranceFlag: FC = () => (
    <svg viewBox="0 0 3 2" width="100%" height="100%" preserveAspectRatio="none" aria-hidden="true">
        <rect width="1" height="2" fill="#002395" />
        <rect x="1" width="1" height="2" fill="#FFFFFF" />
        <rect x="2" width="1" height="2" fill="#ED2939" />
    </svg>
);

const UkraineFlag: FC = () => (
    <svg viewBox="0 0 3 2" width="100%" height="100%" preserveAspectRatio="none" aria-hidden="true">
        <rect width="3" height="1" fill="#005BBB" />
        <rect y="1" width="3" height="1" fill="#FFD500" />
    </svg>
);

const UsFlag: FC = () => {
    const stripeHeight = 16 / 13;

    return (
        <svg
            viewBox="0 0 24 16"
            width="100%"
            height="100%"
            preserveAspectRatio="none"
            aria-hidden="true"
        >
            <rect width="24" height="16" fill="#B22234" />
            {[1, 3, 5, 7, 9, 11].map(index => (
                <rect
                    key={index}
                    y={index * stripeHeight}
                    width="24"
                    height={stripeHeight}
                    fill="#FFFFFF"
                />
            ))}
            <rect width="9.6" height={7 * stripeHeight} fill="#3C3B6E" />
            {US_STARS.map(([cx, cy], index) => (
                <circle key={index} cx={cx} cy={cy} r="0.38" fill="#FFFFFF" />
            ))}
        </svg>
    );
};

const SpainFlag: FC = () => (
    <svg viewBox="0 0 3 2" width="100%" height="100%" preserveAspectRatio="none" aria-hidden="true">
        <rect width="3" height="2" fill="#AA151B" />
        <rect y="0.5" width="3" height="1" fill="#F1BF00" />
    </svg>
);

const FLAGS: Record<string, FC> = {
    fr: FranceFlag,
    ua: UkraineFlag,
    en: UsFlag,
    es: SpainFlag,
};

export const LanguageFlag: FC<TProps> = ({ locale, width = 24 }) => {
    const Flag = FLAGS[locale];

    if (!Flag) {
        return null;
    }

    return (
        <span
            aria-hidden="true"
            style={{
                display: 'inline-flex',
                width,
                height: Math.round((width * 2) / 3),
                borderRadius: 2,
                overflow: 'hidden',
                boxSizing: 'border-box',
                border: '1px solid rgba(0, 0, 0, 0.2)',
                flexShrink: 0,
                lineHeight: 0,
            }}
        >
            <Flag />
        </span>
    );
};
